import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "pm-alert-dialog__inner"
};
const _hoisted_2 = {
  class: "pm-alert-dialog__header"
};
const _hoisted_3 = {
  class: "pm-alert-dialog__title"
};
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = {
  key: 0,
  class: "pm-alert-dialog__message"
};
const _hoisted_6 = {
  key: 1,
  class: "pm-alert-dialog__actions"
};
import PmDialogShell from '@/components/shell/PmDialogShell.vue';
export default {
  __name: 'PmAlertDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeAriaLabel: {
      type: String,
      default: 'Close'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    dialogWidth: {
      type: [String, Number],
      default: '420px'
    },
    zIndex: {
      type: Number,
      default: undefined
    }
  },
  emits: ['update:modelValue', 'cancel', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    function onVisibleChange(open) {
      emit('update:modelValue', open);
      if (!open) emit('cancel');
    }
    function onCancel() {
      emit('update:modelValue', false);
      emit('cancel');
    }
    function onConfirm() {
      emit('confirm');
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PmDialogShell, {
        "model-value": __props.modelValue,
        "dialog-class": "pm-alert-dialog",
        "sheet-class": "pm-alert-dialog-sheet",
        "dialog-width": __props.dialogWidth,
        "z-index": __props.zIndex,
        "show-close": false,
        "close-on-click-modal": __props.closeOnClickModal,
        "destroy-on-close": "",
        "onUpdate:modelValue": onVisibleChange
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1), __props.showClose ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "pm-alert-dialog__close",
          "aria-label": __props.closeAriaLabel,
          onClick: onCancel
        }, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
          viewBox: "0 0 20 20",
          fill: "none",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M5 5l10 10M15 5L5 15",
          stroke: "currentColor",
          "stroke-width": "1.75",
          "stroke-linecap": "round"
        })], -1)]))], 8, _hoisted_4)) : _createCommentVNode("", true)]), __props.message ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.message), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default"), __props.showActions ? (_openBlock(), _createElementBlock("div", _hoisted_6, [__props.cancelText ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "pm-alert-dialog__btn pm-alert-dialog__btn--ghost",
          onClick: onCancel
        }, _toDisplayString(__props.cancelText), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
          type: "button",
          class: "pm-alert-dialog__btn pm-alert-dialog__btn--primary",
          onClick: onConfirm
        }, _toDisplayString(__props.confirmText), 1)])) : _createCommentVNode("", true)])]),
        _: 3
      }, 8, ["model-value", "dialog-width", "z-index", "close-on-click-modal"]);
    };
  }
};